import { getEstimatedDeliveryDate } from './custom-module_estimated-delivery-date.js';

export const getProductHandleFromURL = () => {
  const urlPath = window.location.pathname;
  const pathSegments = urlPath.split('/');
  const productHandle = pathSegments[pathSegments.indexOf('products') + 1];
  return productHandle;
};

// todo: gather product handle from global variable
export const storefronFetchVariantFields = async (variantId) => {
  const token = window.sp.STOREFRONT_ACCESS_TOKEN;
  const productHandle = getProductHandleFromURL();
  const gid = `gid://shopify/ProductVariant/${variantId}`;
  // Storefront API: https://shopify.dev/docs/api/storefront/2024-07/objects/ProductVariant
  const query = `
    query getProductVariant($variantId: ID!) {
      node(id: $variantId) {
        ... on ProductVariant {
          id
          title
          sku
          quantityAvailable
          availableForSale
          metafield(namespace: "netsuite", key: "weight") {
            key
            value
            type
          }
        }
      }
    }
  `;

  const variables = {
    variantId: `gid://shopify/ProductVariant/${variantId}`,
  };

  try {
    const response = await fetch('https://ryonet.myshopify.com/api/2024-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query, variables }),
    });

    const data = await response.json();
    const variant = data.data.product.variant;
    if (!variant) {
      return null;
    }

    const metafields = variant.metafields.edges.reduce((acc, edge) => {
      acc[edge.node.key] = edge.node.value;
      return acc;
    }, {});

    return {
      custitem_show_kit_value_on_web: metafields.custitem_show_kit_value_on_web,
      weight: metafields.weight,
      handling_cost: metafields.handling_cost,
      custitem_kit_value: metafields.custitem_kit_value,
      custitem_gallon_factor: metafields.custitem_gallon_factor,
      isdropshipitem: metafields.isdropshipitem,
      custitem_ryo_inactiveprocess: metafields.custitem_ryo_inactiveprocess,
      custitem_ryo_fulfillmentleadtime: metafields.custitem_ryo_fulfillmentleadtime
    };
  } catch (error) {
    console.error('Error fetching variant metafields:', error);
    return null;
  }
};

export const getVariantMetafield = (variantId, metafieldKey) => {
  const variant = window.sp.product.variants.find(variant => variant.id.toString() === variantId.toString());
  return variant?.metafields[metafieldKey];
};

export const resetMetafieldDisplayById = elementId => {
  const element = document.getElementById(elementId);
  if (element) {
    element.innerHTML = ''; // Clear all child nodes
    element.classList.add('banish');
  } else {
    console.error('Element not found');
  }
};

export const getAvailabilityTable = (waQuantity, paQuantity) => {
  return `<table>
    <caption class="product--inventory-location-caption">Availability</caption>
    <tr>
      <th scope="col" class="product--inventory-location-theader">WA</th>
      <th scope="col" class="product--inventory-location-theader">PA</th>
    </tr>
    <tr>
      <td class="product--inventory-location-tbody">${waQuantity || '-'}</td>
      <td class="product--inventory-location-tbody">${paQuantity || '-'}</td>
    </tr>
  </table>`;
};

export const decimalTrim = (number, precision) => {
  let parts = number.toString().split(".");
  // If there is a decimal part, trim it to the specified precision
  if (parts[1]) {
    parts[1] = parts[1].substring(0, precision);
    // Ensure the decimal part has exactly two digits
    if (parts[1].length < precision) {
      parts[1] = parts[1].padEnd(precision, '0');
    }
  }
  // Join the integer part and the trimmed decimal part back together
  let result = parts.join(".");
  // If the result has a decimal part, ensure it has exactly two decimal places
  if (result.includes(".")) {
    result = parseFloat(result).toFixed(precision);
  }
  return result;
}

export const updateWeightDisplay = variantId => {
  resetMetafieldDisplayById('weight-container');
  if (!variantId) return;
  const weight = getVariantMetafield(variantId, 'weight');
  const weightDisplayElement = document.getElementById('weight-container');

  if (weightDisplayElement && weight) {
    weightDisplayElement.textContent = `${weight} lb`;
    weightDisplayElement.classList.remove('banish');
  } else {
    console.error('Weight display element or weight metafield value not found');
  }
};

export const updateEstimatedDeliveryDisplay = variantId => {
  resetMetafieldDisplayById('estimated-delivery-container');
  if (!variantId) return;
  const variant = window.sp.product.variants.find(variant => variant.id.toString() === variantId.toString());
  const estimatedDelivery = getEstimatedDeliveryDate(variant);
  const estimatedDeliveryContainer = document.getElementById('estimated-delivery-container');

  if (estimatedDelivery === 'no match' || estimatedDelivery === 'no-ship') return console.log('No date returned for estimatedDelivery', estimatedDelivery);

  if (estimatedDeliveryContainer && estimatedDelivery) {
    estimatedDeliveryContainer.innerHTML = estimatedDelivery;
    estimatedDeliveryContainer.classList.remove('banish');
  } else {
    console.error('Estimated delivery display element or estimated delivery value not found');
  }
};

export const updateAvailabilityTable = variantId => {
  resetMetafieldDisplayById('availability-table');
  if (!variantId) return;
  const variant = window.sp.product.variants.find(variant => variant.id.toString() === variantId.toString());
  const waQuantity = variant.metafields['waInventory'];
  const paQuantity = variant.metafields['paInventory'];

  if (!waQuantity && !paQuantity) return console.log('Availability table', 'No inventory data found');
  if (variant.available === false) return console.log('Availability table', 'Product is not available');

  const tableElement = getAvailabilityTable(waQuantity, paQuantity);
  const availabilityTableContainer = document.getElementById('availability-table');

  if (availabilityTableContainer && tableElement) {
    availabilityTableContainer.innerHTML = tableElement;
    availabilityTableContainer.classList.remove('banish');
  } else {
    console.error('Availability table display element or table element not found');
  }

};

export const updateFlatRateDisplay = variantId => {
  resetMetafieldDisplayById('flat-rate');
  if (!variantId) return;
  const variant = window.sp.product.variants.find(variant => variant.id.toString() === variantId.toString());
  const rawFlatrate = variant.metafields.flatrate;

  const productTags = sp.product.tags;
  if (productTags && productTags.includes('non-physical')) return console.log('Non-physical product');

  const showDecimals = getDecimalPlaces(rawFlatrate);

  const flatrateFormatted = rawFlatrate && +rawFlatrate > 0 && rawFlatrate !== ' '
    ? `$${decimalTrim(rawFlatrate, showDecimals)}`
    : null;

  if (!flatrateFormatted) return;

   const flatrateElement = `
    <span class="product-flatrate">
      Ships for 
      <span class="flatrate-cost">
        ${flatrateFormatted}
      </span>
      in contiguous US. Additional shipping charges apply. <a href="https://www.screenprinting.com/pages/request-a-custom-shipping-quote" target="_blank">(Request a custom shipping quote.)</a>
    </span>`;
  const flatRateContainer = document.getElementById('flat-rate');
  
  if (flatRateContainer && flatrateElement) {
    flatRateContainer.innerHTML = flatrateElement;
    flatRateContainer.classList.remove('banish');
  } else {
    console.error('Flat rate display element or flat rate element not found');
  }

  function getDecimalPlaces(rawFlatrate) {
    // Check if rawFlatrate contains a decimal point
    if (rawFlatrate.includes('.')) {
      // Split the number into integer and decimal parts
      const parts = rawFlatrate.split('.');
      const decimalPart = parts[1];

      // Check if the decimal part is greater than zero
      if (parseFloat(decimalPart) > 0) {
        return 2;
      }
    }
    return 0;
  }

};

export const updateKitValueDisplay = variantId => {
  resetMetafieldDisplayById('kit-value-banner-container');
  if (!variantId) return;

  const variant = window.sp.product.variants.find(variant => variant.id.toString() === variantId.toString());
  const showKitValue = (variant.metafields?.showKitValue === "true");
  if (showKitValue === false) return;
  const kitValue = variant.metafields?.kitValue;
  if (kitValue === null || kitValue === 'undefined' || kitValue === '') return;
  const commatize = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const kitValueTitle = `Buy Together and Save!`;
  const kitValueText = `Sells separately for $${commatize(kitValue)}`;

  const kitValueBannerElement = `<div id="kit-value-title" class="product_kit-value-banner-title">${kitValueTitle}</div>
    <div id="kit-value-text" class="product-kit-value--text">${kitValueText}</div>`;

  const kitValueBannerContainer = document.getElementById('kit-value-banner-container');

  if (kitValueBannerContainer && kitValueBannerElement) {
    kitValueBannerContainer.innerHTML = kitValueBannerElement;
    kitValueBannerContainer.classList.remove('banish');
  } else {
    console.error('Kit value banner display element or kit value banner element not found');
  }
}

export const updateDiscontinuedBanner = variantId => {
  resetMetafieldDisplayById('discontinued-banner');
  if (!variantId) return;
  const variant = window.sp.product.variants.find(variant => variant.id.toString() === variantId.toString());
  const hasInactiveDate = (variant.metafields.discontinueDate);

  const discontinuedContainer = document.getElementById('discontinued-banner');

  if (discontinuedContainer && hasInactiveDate) {
    const bannerCopy = `This product size is currently being discontinued. All sales final while supplies last.`;
    const bannerElement = `<span class="product__discontinued-banner--text">${bannerCopy}</div>`;

    discontinuedContainer.innerHTML = bannerElement;
    discontinuedContainer.classList.remove('banish');
  }
};

export const updateFinanceLinks = variantId => {

  // Reset finance links
  const financeElements = document.querySelectorAll('.finance-elements');
  financeElements.forEach(el => el.remove());
  const shopifyPayBanner = document.querySelector('shopify-payment-terms');
  if (shopifyPayBanner) shopifyPayBanner.classList.add('banish');

  if (!variantId) return;
  const variant = window.sp.product.variants.find(variant => variant.id.toString() === variantId.toString());
  if (!variant) return;
  const shopifyPrice = accounting.formatMoney(variant.price / 100, '').replace(',', '');

  const amountToFinance = variant.flatrate && variant.flatrate !== '0' && variant.flatrate !== ' '
    ? parseFloat(shopifyPrice) + parseFloat(variant.flatrate)
    : +shopifyPrice;

  // Add "Earn Member Points" banner
  addRemoveMembersEarn(amountToFinance);

  // Financing ($2,500+)
  if (amountToFinance >= 2500) {
    addFirstCitizensEl(amountToFinance);
  }

  // // Mid-Tier Financing ($2500 - $6999.99) - ClickLease
  // // This section is taken care of by the ClickLease snippet.
  // else if (amountToFinance >= 2500 && amountToFinance < 7000) {
  //   addClickleaseEl(amountToFinance);
  // }

  // Micro-Tier Financing ($50 - $2500) - Shop Pay (native functionality)
  else if (amountToFinance > 50 && amountToFinance < 2500) {
    const element = document.querySelector('shopify-payment-terms');

    if (element) {
      element.classList.remove('banish');
    }
  }

  // Functions
  function getMonthlyPayment(rate, term, price) {
    const monthlyPayment = price * (rate / 12) * (Math.pow((1 + (rate / 12)), term)) / ((Math.pow((1 + (rate / 12)), term)) - 1);
    return Math.round(100 * monthlyPayment) / 100;
  }

  function addRemoveMembersEarn(itemPrice) {
    if (sp.userLoggedIn || itemPrice < 10) return;
    const memberPoints = Math.round(itemPrice * 1); // member points are 1:1 ratio. $1 = 1 points. Updated from 3 on 07/10/25

    const rewardsLinkUrl = '#smile-home';
    const rewardsLinkEl = `<a href="${rewardsLinkUrl}" class="product-members-earn-banner">
      Join Now
    </a>`;
    const membersEarnContentsElement = `<span class="finance-elements">
      Earn ${memberPoints} points towards Member Rewards.
      ${rewardsLinkEl}
    </span>`;

    $('#finance-banners').append(membersEarnContentsElement).show();
  }

  function addFirstCitizensEl(amountToFinance) {
    const duration = 60;
    const rate = 0.0799;
   
    const lowFinance = '$' + Math.round(amountToFinance * 0.027);
    // const citHTML = `
    //     <a href="https://ryonetcorporation.directcapital.com/" class="finance-elements" target="_blank" class="product-cit-link ">
    //       <span class="">As low as <span id="cit-money">${monthlyFinancingRate}</span>/month<span class="product-cit-text-norm"> with </span></span>
    //       <img class="product-cit-image" src="https://cdn.shopify.com/s/files/1/2636/4748/files/first-citizens-bank-logo-and-name.png?v=1716248155">
    //     </a>
    //   `;
    if(+amountToFinance < 7000){
      var monthlyFinancingRate = `$${Math.ceil(amountToFinance * 0.027)}`;
    } else {
       var monthlyFinancingRate = `$${Math.ceil(getMonthlyPayment(rate, duration, amountToFinance))}`;
    }
    const citHTML = `
    <span class="finance-elements"><br>As low as  <strong>${monthlyFinancingRate}</strong>/month. 
        <a href="/pages/finance-interest" class="" target="_blank">
          <span class="product-vendor">Find Your Solution</span></span>
        </a>
    `;
    $('#finance-banners').append(citHTML).show();
  }

  // function addClickleaseEl(amountToFinance) {
  //   const clickleaseLogo = '<svg class="clicklease-logo-size" id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 449.383 87.949"> <path id="Path_826" data-name="Path 826" d="M398.082,75.931,386.773,59.055V75.931H377.25v-48h9.523V56.324l10.608-15.685h10.994L396.436,57.445l13.2,18.486Z" transform="translate(-144.354 -14.836)" fill="#009fdf"></path> <path id="Path_827" data-name="Path 827" d="M389.58,27.93H399.1v48H389.58Z" transform="translate(-113.514 -14.836)" fill="#707372"></path> <path id="Path_828" data-name="Path 828" d="M430.652,52.567H403.938c.84,4.832,3.991,7.457,8.613,7.457a8.408,8.408,0,0,0,7.492-4.1h10.013a18.04,18.04,0,0,1-17.506,12.6c-10.434,0-18.311-8.053-18.311-18.626,0-10.644,7.843-18.626,18.311-18.626,10.818,0,18.276,8.368,18.276,18.521A18.64,18.64,0,0,1,430.652,52.567Zm-26.434-6.512H421.3c-1.331-4.306-4.446-6.652-8.718-6.652C408.35,39.4,405.3,41.888,404.218,46.055Z" transform="translate(-101.859 -6.457)" fill="#707372"></path> <path id="Path_829" data-name="Path 829" d="M444.227,32.215V67.507h-7.492l-.805-3.151a17.051,17.051,0,0,1-11.449,4.2c-10.609,0-18.521-8.018-18.521-18.7,0-10.643,7.913-18.591,18.521-18.591a17.322,17.322,0,0,1,11.589,4.306l1.015-3.361h7.142Zm-9.348,17.646a9.611,9.611,0,1,0-19.221,0,9.611,9.611,0,1,0,19.221,0Z" transform="translate(-72.546 -6.482)" fill="#707372"></path> <path id="Path_830" data-name="Path 830" d="M433.67,68.532c-8.858,0-14.775-5.042-14.81-12.6h9.313c.035,3.151,2.451,4.727,5.882,4.727,2.661,0,5.007-1.19,5.007-3.571,0-2.416-3.046-3.151-6.792-3.781-5.637-.945-12.814-2.451-12.814-10.749,0-6.687,5.672-11.274,14.18-11.274s14.11,4.727,14.145,11.8h-9.068c-.035-2.8-2-4.2-5.322-4.2-2.976,0-4.727,1.365-4.727,3.4,0,2.346,3.011,2.906,6.687,3.571,5.742,1.05,13.094,2.241,13.094,10.854,0,7.142-5.882,11.834-14.775,11.834Z" transform="translate(-40.281 -6.457)" fill="#707372"></path> <path id="Path_831" data-name="Path 831" d="M465.042,52.567H438.328c.84,4.832,3.991,7.457,8.613,7.457a8.408,8.408,0,0,0,7.493-4.1h10.013a18.04,18.04,0,0,1-17.506,12.6c-10.433,0-18.311-8.053-18.311-18.626,0-10.644,7.842-18.626,18.311-18.626,10.819,0,18.276,8.368,18.276,18.521A14.868,14.868,0,0,1,465.042,52.567Zm-26.434-6.512h17.086c-1.33-4.306-4.447-6.652-8.718-6.652C442.74,39.4,439.694,41.888,438.608,46.055Z" transform="translate(-15.845 -6.457)" fill="#707372"></path> <path id="Path_832" data-name="Path 832" d="M370.915,81.224a20.832,20.832,0,1,1,0-26.119l21.462-9.593a43.974,43.974,0,1,0,0,45.3Z" transform="translate(-310.73 -24.19)" fill="#009fdf"></path> <path id="XMLID_6244_" d="M369.209,31.21l-21.707,9.7-21.742,9.7L347.5,60.3l21.707,9.663-5.742-19.361h0Z" transform="translate(-273.138 -6.632)" fill="#707372"></path> <path id="Path_833" data-name="Path 833" d="M390.808,55.438a8.823,8.823,0,1,1,0-11.064l9.1-4.061a18.626,18.626,0,1,0,0,19.186Z" transform="translate(-174.192 -6.457)" fill="#009fdf"></path> <path id="Path_834" data-name="Path 834" d="M355.31,27.93h9.523v48H355.31Z" transform="translate(-199.229 -14.836)" fill="#009fdf"></path> <path id="Path_835" data-name="Path 835" d="M360.64,41.264h9.523V76.556H360.64Zm.035-13.584h9.488v8.858h-9.488Z" transform="translate(-185.898 -15.461)" fill="#009fdf"></path> <path id="Path_836" data-name="Path 836" d="M369.118,55.438a8.823,8.823,0,1,1,0-11.064l9.1-4.061a18.626,18.626,0,1,0,0,19.186Z" transform="translate(-228.442 -6.457)" fill="#009fdf"></path></svg>';
    
  //   // const clickLeaseHTML = `
  //   //     <a href="https://www.clicklease.com/partner/ryonet" class="finance-elements" target="_blank" class="product-clicklease-link">
  //   //       <span class="product-clicklease-text-bold">As low as <span id="clicklease-money">${monthlyFinancingRate}</span>/month<span class="product-clicklease-text-norm"> with ${clickleaseLogo}</span></span>
  //   //     </a>
  //   //   `;
  //   const clickLeaseHTML = `
  //       <br><span class="">As low as  <strong>${monthlyFinancingRate}</strong>/month. </span>
  //       <a href="/pages/finance-interest" class="" target="_blank">
  //         <span class="product-vendor">Find Your Solution</span>
  //       </a>
  //     `;
  //   $('#finance-banners').append(clickLeaseHTML).show();
  // }

};

const initKlaviyoOutOfStock = () => {
  try {
    klaviyo.init({
      account: "MNbufh",
      platform: "shopify"
    });
    klaviyo.enable("backinstock", {
      trigger: {
        product_page_text: "Notify Me When Available",
        product_page_class: "btn btn--primary w-full vanish",
        product_page_text_align: "center",
        product_page_margin: "10px 0",
        replace_anchor: false
      },
      modal: {
        headline: "{product_name}",
        body_content: "Register to receive a notification when this item comes back in stock.",
        email_field_label: "Email",
        button_label: "Notify me when available",
        subscription_success_label: "You're in! We'll let you know when it's back.",
        footer_content: '',
        additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
        drop_background_color: "#000",
        background_color: "#fff",
        text_color: "#222",
        button_text_color: "#fff",
        button_background_color: "#df0040",
        close_button_color: "#ccc",
        error_background_color: "#fcd6d7",
        error_text_color: "#C72E2F",
        success_background_color: "#d3efcd",
        success_text_color: "#1B9500"
      }
    });
  } catch (e) {
    console.log("Klavio failure", e);
  }
}

const updateKlaviyoOutOfStockDisplay = variantId => {
  if (!variantId) $('.klaviyo-bis-trigger').addClass('vanish').removeClass('product--klaviyo-out-of-stock-button');

  const variant = window.sp.product.variants.find(variant => variant.id.toString() === variantId.toString());
  const cantSellPastZero = (variant.inventoryPolicy === 'deny');
  const variantQuantity = +variant.inventory;
  const waitTime = 600;
  const atcIsDisabled = document.querySelector('.product-info__add-button button').disabled;

  setTimeout(function () {
    if (cantSellPastZero && variantQuantity < 1 && atcIsDisabled) {
      $('.klaviyo-bis-trigger').removeClass('vanish').addClass('product--klaviyo-out-of-stock-button');
    } else {
      $('.klaviyo-bis-trigger').addClass('vanish').removeClass('product--klaviyo-out-of-stock-button');
    }
  }, waitTime);
}

export const updatePriceWasDisplay = variantId => {
  // An app (can't remember which) can add a "was" price even when it's identical to the 
  // current price, so, we're hiding the "was" price after a delay if needed.

  setTimeout(() => {
    const priceWasContainer = document.querySelector('.product-info__price .price__was');
    const priceWas = priceWasContainer?.textContent;
    const priceCurrent = document.querySelector('.product-info__price .price__current')?.textContent;

    if (priceWas === priceCurrent) {
      priceWasContainer.classList.add('banish');
    } else {
      priceWasContainer.classList.remove('banish');
    }
  }, 900);
};

export const updateGallonFactorDisplay = variantId => {
  resetMetafieldDisplayById('per-gal');
  if (!variantId) return;
  const variant = window.sp.product.variants.find(variant => variant.id.toString() === variantId.toString());
  const gallonFactor = getVariantMetafield(variantId, 'gallonFactor');
  const shopifyPrice = variant.price;
  let perGalDbPrice = (shopifyPrice / 100) * gallonFactor;
  perGalDbPrice = decimalTrim(perGalDbPrice, 2);
  if (+perGalDbPrice <= 0) return;
  const pricePerGallonSpan = document.getElementById('per-gal');

  if (pricePerGallonSpan && perGalDbPrice) {
    pricePerGallonSpan.textContent = `$${perGalDbPrice}/gal`;
    pricePerGallonSpan.classList.remove('banish');
  } else {
    console.error('Price per gallon display element or price per gallon value not found');
  }
};

export const updateSalePercentageDisplay = variantId => {
  resetMetafieldDisplayById('sale-percentage');
  if (!variantId) return;
  const variant = window.sp.product.variants.find(variant => variant.id.toString() === variantId.toString());

  const price = variant.price;
  const compareAtPrice = variant.compare_at_price;
  const salePercentage = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);

  if (isNaN(salePercentage) || salePercentage <= 0) return console.log("returned");

  const salePercentageElement = document.getElementById('sale-percentage');

  if (salePercentageElement && salePercentage) {
    salePercentageElement.textContent = `Save ${salePercentage}%`;
    salePercentageElement.classList.remove('banish');
  }
};


/**
 * Initialize product page
 */
export const initializeProductPage = async () => {

  // DISPLAY VARIANT FIELDS ON VARIANT CHANGE
  document.addEventListener('on:variant:change', async (event) => {
    // If user chooses variant options that don't match a variant, event.detail.variant will be undefined.
    // However, we will still need to clear out the banners. So, when no vID is passed, it should be treated as a clear.
    const variantId = event.detail.variant?.id;
    updateWeightDisplay(variantId);  // TODO: remove this if we end up keeping the native weight field
    updateEstimatedDeliveryDisplay(variantId);
    updateAvailabilityTable(variantId);
    updateGallonFactorDisplay(variantId);
    updateFinanceLinks(variantId);
    updateDiscontinuedBanner(variantId);
    updateKitValueDisplay(variantId);
    updateFlatRateDisplay(variantId);
    updateKlaviyoOutOfStockDisplay(variantId);
    updateSalePercentageDisplay(variantId);
    updatePriceWasDisplay(variantId);

  });

  const initializeProductContent = async () => {
    const initialVariantId = window.sp.product.initialVariantId;
    updateWeightDisplay(initialVariantId);  // TODO: remove this if we end up keeping the native weight field
    updateEstimatedDeliveryDisplay(initialVariantId);
    updateAvailabilityTable(initialVariantId);
    updateGallonFactorDisplay(initialVariantId);
    updateFinanceLinks(initialVariantId);
    updateDiscontinuedBanner(initialVariantId);
    updateKitValueDisplay(initialVariantId);
    updateFlatRateDisplay(initialVariantId);
    updateKlaviyoOutOfStockDisplay(initialVariantId);
    updateSalePercentageDisplay(initialVariantId);
    updatePriceWasDisplay(initialVariantId);

    initKlaviyoOutOfStock(initialVariantId);
  };

  // DOMContentLoaded was not working for this setup
  document.onreadystatechange = () => {
    if (document.readyState === 'complete') initializeProductContent();
  }
};